/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

// keep track of active iframes on the page
// data type: [{ id: string, url: string}]
let activeFrames = [];

/**
 * Check if a frame exists in active frames collection
 * @param {string} id frame id
 * @returns true/false
 */
const frameExists = (id) => {
	return !!activeFrames.find((f) => f.id === id);
};

/**
 * Send data to iframe
 * @param {string} iframeId frame id as it appears in the DOM
 * @param {string} targetOrigin frame url as it appears in the DOM
 * @param {string} type payload type
 * @param {Object} payload data to pass in to the iframe
 */
const pushToFrame = (iframeId, targetOrigin, type, payload) => {
	const frame = document.getElementById(iframeId);
	if (frame) {
		const win = frame.contentWindow;
		win.postMessage(JSON.stringify({ type, payload }), targetOrigin);
	}
};

/**
 * Add iframe to active frames collection
 * @param {string} id frame id
 * @param {string} url frame url
 */
export const addFrame = (id, url) => {
	if (frameExists(id)) {
		removeFrame(id);
	}
	activeFrames = [...activeFrames, { id, url }];
};

/**
 * Remove iframe from frames collection
 * @param {string} id frame id
 */
export const removeFrame = (id) => {
	activeFrames = [...activeFrames.filter((f) => f.id !== id)];
};

/**
 * Push contact update to all frames in the active frames collection
 * @param {Object} contact
 */
export const contactChangedAction = (contact) => {
	activeFrames.forEach(({ id, url }) => {
		pushToFrame(id, url, "pace/contact_changed", { contact });
	});
};

/**
 * Notify iframes in the active frames collection that the contact ended
 * @param {string} contactId
 */
export const contactEndedAction = (contactId) => {
	activeFrames.forEach(({ id, url }) => {
		pushToFrame(id, url, "pace/contact_ended", { contactId });
	});
};
